/**
 * @generated SignedSource<<2c1b38da1cb10c936ba9f9b9d4d5022e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAllowCustomQuote_buyer$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly isVip: boolean | null;
  readonly " $fragmentType": "CheckoutAllowCustomQuote_buyer";
};
export type CheckoutAllowCustomQuote_buyer$key = {
  readonly " $data"?: CheckoutAllowCustomQuote_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAllowCustomQuote_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutAllowCustomQuote_buyer",
  "selections": [
    {
      "alias": "isVerifiedTrade",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_NET_PRICE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVip",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "57e9952381883a1e93df08dd41897ca9";

export default node;
